
import styles from "./LentraDowntime.module.scss";
import { Link } from "react-router-dom";

export default function LentraDowntime() {
  
  return (
    <div className={styles.wrapper}>
      <div className={styles.mobileContainer}>
       
        {/* Content */}
        <main className={styles.content}>
          <section className={styles.maintenanceCard}>
            <div className={styles.statusBadge}>
              <span />
              In progress
            </div>

            <h1>
              We're Under
              <br />
              Maintenance
            </h1>

            <img src="/images/fetching-data.jpg" alt="" />

            <p className={styles.description}>
              We're currently under maintenance. We're

              working to restore services shortly. Thank
             
              you for your patience.
            </p>

            <div className={styles.progressTitle}>
              <span className={styles.progressDot} />
              <strong>Restoring services</strong>
            </div>

            <div className={styles.progressBar}>
              <div className={styles.progress} />
            </div>
          </section>

          {/* Support */}
          <button className={styles.supportButton}>
            <span>Need help now?</span>
            <Link to="/contact-us">
            Contact support
            </Link>
          </button>
        </main>

        
      </div>
    </div>
  );
}
